module.exports = __webpack_public_path__ + "img/health-details.30e333ec.svg";